$shm_hitalama_chat $shm_hitalama_page
	resize_side \left
	title \AI-агент
	tools /
		<= Logs_clear $mol_button_minor
			title \Очистить
			click? <=> logs_clear? null
	body /
		^ messages /
	Message* $mol_card
		sub /
			- <= Message_author_speck* $mol_speck
				value <= message_author* \AI-агент
			<= Message_head* $mol_view
				sub /
					<= Message_author* $mol_paragraph
						title <= message_author* \AI-агент
					<= Message_date* $mol_paragraph
						title <= message_date* \2026-01-12 08:14:01
			<= Message_text* $shm_hitalama_text
				text <= message_text* \
			- <= Message_text* $mol_paragraph
				title <= message_text* \
	foot /
		<= Textarea $mol_textarea
			value? <=> draft? \
			submit? <=> send? null
		<= Send $mol_button_minor
			sub / <= Send_icon $mol_icon_send
			click? <=> send? null
